module.exports = __webpack_public_path__ + "img/img10.8d092aaa.jpg";